import React, { useCallback } from 'react';
import { Header } from 'common/components/Header';
import { FormikOnSubmit } from 'lib/formik.utils';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useMutation, useQueryCache } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { Button, message, Form as AntForm } from 'antd';
import { useEnsureContext } from 'common/hooks';
import { Formik } from 'formik';
import { Form, FormItem, Input } from 'formik-antd';
import {
  defaultFormLayout,
  defaultFormTailLayout,
} from 'common/config/formLayout';
import { requiredEmailValidationSchema } from 'common/config/validationSchema';
import { object } from 'yup';
import { useHistory } from 'react-router';
import { SubpartnersRegisterSelect } from 'common/components/SubpartnersSelect';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerRoutes } from 'pages/BusinessPartnerManagement/businessPartnerRoutes';
import { useRole } from 'common/hooks/useRole';
import { isNil } from 'ramda';
export interface RegisterBusinessPartnerAdminUserFormModel {
  partner: any;
  email: string;
}

export const BusinessPartnerRegisterAdminPage = () => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const queryCache = useQueryCache();

  const [mutate, { isLoading }] = useMutation(
    BusinessPartnersAPI.registerNewAdminUser
  );

  const { isMedicalOperator } = useRole();
  const shouldHidePartnerDropdown =
    !isNil(bpContext.parentPartnerId) || isMedicalOperator;

  const history = useHistory();
  const intlMessage = useFormatMessage();

  const validationSchema = object().shape({
    email: requiredEmailValidationSchema(intlMessage),
  });

  const handleSubmit: FormikOnSubmit<RegisterBusinessPartnerAdminUserFormModel> = useCallback(
    (formData, { resetForm }) => {
      mutate(
        {
          businessPartnerId: formData.partner ? formData.partner : bpContext.id,
          dto: formData,
        },
        {
          onSuccess: () => {
            resetForm();
            queryCache
              .invalidateQueries(QueryKey.BusinessPartnerDoctorsList)
              .then();
            message.success(intlMessage({ id: 'admins.register.success' }));
            history.push(`../${BusinessPartnerRoutes.Admins}`);
          },
        }
      ).then();
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bpContext, mutate, queryCache]
  );

  return (
    <>
      <Header title={intlMessage({ id: 'admins.new' })} />
      <Formik
        initialValues={{ email: '', partner: '' }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        <Form {...defaultFormLayout}>
          <FormItem label={intlMessage({ id: 'email' })} name="email" required>
            <Input name="email" />
          </FormItem>
          {!shouldHidePartnerDropdown && (
            <FormItem label={intlMessage({ id: 'partner' })} name="partner">
              <SubpartnersRegisterSelect name="partner" />
            </FormItem>
          )}
          <AntForm.Item {...defaultFormTailLayout}>
            <Button
              id="button-save-register-admin"
              loading={isLoading}
              type="primary"
              htmlType="submit"
            >
              {isLoading
                ? intlMessage({ id: 'saving' })
                : intlMessage({ id: 'save' })}
            </Button>
          </AntForm.Item>
        </Form>
      </Formik>
    </>
  );
};
